export class TokenResponse {
    token: string
    refreshToken: string
    userData: {
        name?: string
        surname?: string
        customerId?: number
    }
}
